const themeOverrides = {
  components: {
    MuiGrid: {
      styleOverrides: {
        root: ({ownerState}) => ({
          width: ownerState.container ? "100%" : undefined,
          minWidth: "auto"
        })
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          padding: "6px 12px 8px"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          lineHeight: "1.75",
          minWidth: "160px"
        }
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: "standard"
      },
      styleOverrides: {
        root: {
          "& .MuiTextField-root": {
            marginTop: "8px"
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: 0,
          "& .MuiCheckbox-root": {
            marginRight: "4px"
          }
        },
        label: ({theme}) => ({
          "&.Mui-disabled": {
            color: theme.palette.grey[600]
          }
        })
      }
    },
    MuiTooltip: {
      defaultProps: {
        disableInteractive: true
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard"
      }
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: ({theme}) => ({
          "&:not(.Mui-checked) .MuiSwitch-thumb": {
            backgroundColor: theme.palette.grey[700],
            opacity: 1
          },
          "&:not(.Mui-checked) + .MuiSwitch-track": {
            backgroundColor: theme.palette.grey[400],
            opacity: 1
          },
          "&.Mui-disabled:not(.Mui-checked) .MuiSwitch-thumb": {
            backgroundColor: theme.palette.grey[600],
            opacity: 1
          },
          "&.Mui-disabled:not(.Mui-checked) + .MuiSwitch-track": {
            backgroundColor: theme.palette.grey[400],
            opacity: 1
          }
        })
      }
    }
  }
};

export const DEFAULT_THEME = {
  palette: {
    text: {
      primary: "#273549"
    },
    primary: {
      main: "#273549",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#f8a81e",
      contrastText: "#273549"
    }
  },
  ...themeOverrides
};

export const DEFAULT_ALL1_THEME = {
  palette: {
    text: {
      primary: "#000000"
    },
    primary: {
      main: "#000000",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#000000",
      contrastText: "#ffffff"
    }
  },
  ...themeOverrides
};
